import ReactLoading from 'react-loading';
import PropTypes from 'prop-types';

const LoadingWrapper = ({ className, children = null, loading }) => {
    if (!loading) return null;
    return (
        <div className={`flex justify-center items-center py-8 ${className || ''}`}>
            <ReactLoading type='bubbles' color='#0284c7' height={56} width={56} />
            {children}
        </div>
    );
}

LoadingWrapper.propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default LoadingWrapper;
